export default __webpack_public_path__ + "static/media/niger.269c98a5.jpg";